var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 638.717,
    height: 376.082,
    viewBox: "0 0 638.717 376.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-262 -93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(324.162 93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32194",
    "data-name": "Path 32194",
    d: "M15.541,0H500.406a15.541,15.541,0,0,1,15.541,15.541V338.784H0V15.541A15.541,15.541,0,0,1,15.541,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32195",
    "data-name": "Path 32195",
    d: "M14.155,2.5H499.021a11.655,11.655,0,0,1,11.655,11.655V333.514H2.5V14.155A11.655,11.655,0,0,1,14.155,2.5Z",
    transform: "translate(1.385 1.385)",
    fill: "none",
    stroke: "#6264a7",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(900.717 469.081) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32196",
    "data-name": "Path 32196",
    d: "M15.541,0H623.176a15.541,15.541,0,0,1,15.541,15.541v9.324H0V15.541A15.541,15.541,0,0,1,15.541,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32197",
    "data-name": "Path 32197",
    d: "M7.77,0H615.406a7.77,7.77,0,0,1,7.77,7.77V9.324H0V7.77A7.77,7.77,0,0,1,7.77,0Z",
    transform: "translate(7.77 7.77)",
    fill: "none",
    stroke: "#6264a7",
    strokeWidth: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.25e787d8c34e66df0b71611d72358b6e.svg";
export { ForwardRef as ReactComponent };